import styled from 'styled-components'

export const Caption = styled.h3`
  font-family: inherit;
  text-transform: uppercase;
  color: inherit;
`
